const TOKEN_KEY = 'admin_token'
const REMEMBER_KEY = 'admin_remember_me'
const USERNAME_KEY = 'admin_remember_username'

export function getAdminToken() {
  return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY)
}

export function setAdminToken(token, rememberMe = true) {
  localStorage.removeItem(TOKEN_KEY)
  sessionStorage.removeItem(TOKEN_KEY)

  if (rememberMe) {
    localStorage.setItem(TOKEN_KEY, token)
  } else {
    sessionStorage.setItem(TOKEN_KEY, token)
  }
}

export function clearAdminToken() {
  localStorage.removeItem(TOKEN_KEY)
  sessionStorage.removeItem(TOKEN_KEY)
}

export function getRememberMePreference() {
  return localStorage.getItem(REMEMBER_KEY) !== '0'
}

export function setRememberMePreference(rememberMe, username = '') {
  localStorage.setItem(REMEMBER_KEY, rememberMe ? '1' : '0')

  if (rememberMe && username) {
    localStorage.setItem(USERNAME_KEY, username)
  } else {
    localStorage.removeItem(USERNAME_KEY)
  }
}

export function getRememberedUsername() {
  return getRememberMePreference() ? localStorage.getItem(USERNAME_KEY) || '' : ''
}
